import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
export const rtoSlice = createSlice({
  name: "rto",
  initialState: {
    loginError: "aaa",
    message: null,
    loading: false,
    frcModal: false,
    uploadLoading: false,
    echallanLoading: false,
    model: false,
    drawer: false,
    viewModal: false,
    apiError: {},
    rtoData: {},
    rtoUpdateData: {},
    documentChecklist: null,
    tokenData: null,
    holdData: null,
    holdHistoryList: [],
    holdHistorySummary: null,
    // E-Challan transactions state
    echallanTransactions: [],
    echallanSummary: {
      total_challan_amount: 0,
      total_paid_amount: 0,
      remaining_amount: 0,
      total_transactions: 0,
      cleared_count: 0,
      is_all_cleared: false,
    },
    listCount: 0,
    newRtoList: [],
    rtoparams: {
      start_date: "",
      end_date: "",
      rtatype: "",
      rtastatus: "",
      is_echallan_clear: "",
      is_token_generated: "",
      is_document_verified: "",
      is_ownership_transferred: "",
      is_hold_amount_released: "",
      is_hold_amount_transferred: "",
      pending_type: "",
      pending_reason: "",
      transfer_type: "",
      ownership_status: "",
      rta_office: "",
      "counter__zone": "",
      "counter__division": "",
      "counter__cluster": "",
      counter: "",
      doc_status: "",
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "id",
      sortOrder: "-",
    },
    purchaseHistoryList: [],
    saleHistoryList: [],
    vehicleHistoryCount: 0,
    saleHistoryCount: 0,
    rtaHistoryList: [],
    // RTA Employees (staff for ownership transfer)
    rtaEmployees: [],
    rtaEmployeesLoading: false,
    // Token History
    tokenHistoryList: [],
    tokenHistoryLoading: false,
    // ── FRC-specific state ────────────────────────────────────────────────
    frcList: [],
    frcListCount: 0,
    frcData: {},
    frcDocumentChecklist: null,
    frcTokenData: null,
    frcTokenHistoryList: [],
    frcEchallanTransactions: [],
    frcEchallanSummary: {
      total_challan_amount: 0,
      total_paid_amount: 0,
      remaining_amount: 0,
      total_transactions: 0,
      cleared_count: 0,
      is_all_cleared: false,
    },
    frcparams: {
      start_date: "",
      end_date: "",
      rtastatus: "",
      is_echallan_clear: "",
      is_token_generated: "",
      is_document_verified: "",
      is_ownership_transferred: "",
      rta_office: "",
      "counter__zone": "",
      "counter__division": "",
      "counter__cluster": "",
      counter: "",
      has_rejected_docs: "",
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "id",
      sortOrder: "-",
    },
  },
  reducers: {
    getRtoList: (state, action) => {
      if (state.rtoparams?.page == 1) {
        return {
          ...state,
          loading: true,
          listCount: 0,
          newRtoList: [],
        };
      } else {
        return {
          ...state,
          loading: true,
        };
      }
    },
    
    // Document Checklist
    getDocumentChecklist: (state, action) => {
      return { ...state, loading: true };
    },
    documentChecklistSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        documentChecklist: action.payload,
      };
    },
    
    // Upload Document
    uploadDocument: (state, action) => {
      return { ...state, uploadLoading: true };
    },
    uploadDocumentSuccessful: (state, action) => {
      return { ...state, uploadLoading: false };
    },
    
    // Verify Documents
    verifyDocuments: (state, action) => {
      return { ...state, loading: true };
    },
    verifyDocumentsSuccessful: (state, action) => {
      return { ...state, loading: false };
    },
    
    // Token Details
    getTokenDetails: (state, action) => {
      return { ...state, loading: true };
    },
    tokenDetailsSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        tokenData: action.payload,
      };
    },
    updateTokenDetails: (state, action) => {
      return { ...state, loading: true };
    },
    
    // Approve / Verify Token
    approveToken: (state, action) => {
      return { ...state, loading: true };
    },
    approveTokenSuccessful: (state, action) => {
      return { ...state, loading: false };
    },

    // Reject / Invalidate Active Token
    rejectToken: (state, action) => {
      return { ...state, loading: true };
    },
    rejectTokenSuccessful: (state, action) => {
      return { ...state, loading: false, tokenData: null };
    },
    
    // Pending Reason
    setPendingReason: (state, action) => {
      return { ...state, loading: true };
    },
    clearPendingReason: (state, action) => {
      return { ...state, loading: true };
    },
    pendingReasonSuccessful: (state, action) => {
      return { ...state, loading: false };
    },
    
    // Hold Amount
    getHoldAmount: (state, action) => {
      return { ...state, loading: true };
    },
    holdAmountSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        holdData: action.payload,
      };
    },
    getHoldHistory: (state, action) => {
      return { ...state, loading: true };
    },
    holdHistorySuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        holdHistoryList: action.payload.transactions || [],
        holdHistorySummary: action.payload.summary || null,
      };
    },
    setHoldAmount: (state, action) => {
      return { ...state, loading: true };
    },
    releaseHoldAmount: (state, action) => {
      return { ...state, loading: true };
    },
    markHoldAsTransferred: (state, action) => {
      return { ...state, loading: true };
    },
    updateRtaStatus: (state, action) => {
      return { ...state, loading: true };
    },
    updateRtaOffice: (state, action) => {
      return { ...state, loading: true };
    },
    updateRtaOfficeSuccessful: (state, action) => {
      return { ...state, loading: false };
    },
    updateOwnershipStatus: (state, action) => {
      return { ...state, loading: true };
    },
    forfeitHoldAmount: (state, action) => {
      return { ...state, loading: true };
    },
    
    // E-Challan Manual Validation
    validateEChallan: (state, action) => {
      return { ...state, loading: true };
    },
    validateEChallanSuccessful: (state, action) => {
      return { ...state, loading: false };
    },
    
    // E-Challan Transactions (Multi-transaction flow)
    getEchallanTransactions: (state, action) => {
      return { ...state, echallanLoading: true };
    },
    echallanTransactionsSuccessful: (state, action) => {
      return {
        ...state,
        echallanLoading: false,
        echallanTransactions: action.payload.transactions || [],
        echallanSummary: {
          total_challan_amount: action.payload.total_challan_amount || 0,
          total_paid_amount: action.payload.total_paid_amount || 0,
          remaining_amount: action.payload.remaining_amount || 0,
          total_transactions: action.payload.total_transactions || 0,
          cleared_count: action.payload.cleared_count || 0,
          is_all_cleared: action.payload.is_all_cleared || false,
        },
      };
    },
    createEchallanTransaction: (state, action) => {
      return { ...state, echallanLoading: true };
    },
    createEchallanTransactionSuccessful: (state, action) => {
      return { ...state, echallanLoading: false };
    },
    updateEchallanTransaction: (state, action) => {
      return { ...state, echallanLoading: true };
    },
    updateEchallanTransactionSuccessful: (state, action) => {
      return { ...state, echallanLoading: false };
    },
    
    // Ownership Transfer
    markOwnershipTransferred: (state, action) => {
      return { ...state, loading: true };
    },
    ownershipTransferSuccessful: (state, action) => {
      return { ...state, loading: false };
    },
    
    // Close RTA
    closeRta: (state, action) => {
      return { ...state, loading: true };
    },
    closeRtaSuccessful: (state, action) => {
      return { ...state, loading: false };
    },
    
    // Vehicle History
    getPurchaseHistory: (state, action) => {
      return { ...state, loading: true };
    },
    purchaseHistorySuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        purchaseHistoryList: action.payload.results || [],
        vehicleHistoryCount: action.payload.count || 0,
      };
    },
    getSaleHistory: (state, action) => {
      return { ...state, loading: true };
    },
    saleHistorySuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        saleHistoryList: action.payload.results || [],
        saleHistoryCount: action.payload.count || 0,
      };
    },
    
    // RTA History
    getRtaHistory: (state, action) => {
      return { ...state, loading: true };
    },
    rtaHistorySuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        rtaHistoryList: action.payload || [],
      };
    },
    
    // FRC Create
    createFrcRta: (state) => {
      return { ...state, loading: true };
    },
    createFrcRtaSuccessful: (state) => {
      return { ...state, loading: false };
    },
    isFrcModalVisible: (state, action) => {
      return { ...state, frcModal: action.payload };
    },

    // ── FRC-specific actions (dedicated /frc/ endpoints) ──────────────────

    // FRC List
    getFrcList: (state) => {
      return { ...state, loading: true, frcList: [], frcListCount: 0 };
    },
    frcListSuccessful: (state, action) => {
      const noofpages = Math.ceil(
        action.payload.response.count / state.frcparams?.page_size
      );
      return {
        ...state,
        loading: false,
        frcList: action.payload.response.results,
        frcListCount: action.payload.response.count,
        frcparams: { ...state.frcparams, no_of_pages: noofpages },
      };
    },
    setFrcParams: (state, action) => {
      return { ...state, frcparams: action.payload };
    },

    // FRC Detail
    getFrcById: (state) => {
      return { ...state, loading: true };
    },
    frcByIdSuccessful: (state, action) => {
      return { ...state, loading: false, frcData: action.payload };
    },

    // FRC Status
    updateFrcStatus: (state) => {
      return { ...state, loading: true };
    },

    // FRC Document Upload
    uploadFrcDocument: (state) => {
      return { ...state, uploadLoading: true };
    },
    uploadFrcDocumentSuccessful: (state) => {
      return { ...state, uploadLoading: false };
    },

    // FRC Document Verify
    verifyFrcDocuments: (state) => {
      return { ...state, loading: true };
    },
    verifyFrcDocumentsSuccessful: (state) => {
      return { ...state, loading: false };
    },

    // FRC Document Checklist
    getFrcDocumentChecklist: (state) => {
      return { ...state, loading: true };
    },
    frcDocumentChecklistSuccessful: (state, action) => {
      return { ...state, loading: false, frcDocumentChecklist: action.payload };
    },

    // FRC Token
    getFrcTokenDetails: (state) => {
      return { ...state, loading: true };
    },
    frcTokenDetailsSuccessful: (state, action) => {
      return { ...state, loading: false, frcTokenData: action.payload };
    },
    updateFrcTokenDetails: (state) => {
      return { ...state, loading: true };
    },
    getFrcTokenHistory: (state) => {
      return { ...state, tokenHistoryLoading: true };
    },
    frcTokenHistorySuccessful: (state, action) => {
      return { ...state, tokenHistoryLoading: false, frcTokenHistoryList: action.payload };
    },

    // FRC E-Challan
    getFrcEchallanTransactions: (state) => {
      return { ...state, echallanLoading: true };
    },
    frcEchallanTransactionsSuccessful: (state, action) => {
      return {
        ...state,
        echallanLoading: false,
        frcEchallanTransactions: action.payload.transactions || [],
        frcEchallanSummary: {
          total_challan_amount: action.payload.total_challan_amount || 0,
          total_paid_amount:    action.payload.total_paid_amount    || 0,
          remaining_amount:     action.payload.remaining_amount     || 0,
          total_transactions:   action.payload.total_transactions   || 0,
          cleared_count:        action.payload.cleared_count        || 0,
          is_all_cleared:       action.payload.is_echallan_clear    || false,
        },
      };
    },
    createFrcEchallanTransaction: (state) => {
      return { ...state, echallanLoading: true };
    },
    createFrcEchallanTransactionSuccessful: (state) => {
      return { ...state, echallanLoading: false };
    },
    updateFrcEchallanTransaction: (state) => {
      return { ...state, echallanLoading: true };
    },
    updateFrcEchallanTransactionSuccessful: (state) => {
      return { ...state, echallanLoading: false };
    },

    // FRC Ownership Transfer
    markFrcOwnershipTransferred: (state) => {
      return { ...state, loading: true };
    },
    frcOwnershipTransferSuccessful: (state) => {
      return { ...state, loading: false };
    },

    // FRC Close
    closeFrc: (state) => {
      return { ...state, loading: true };
    },
    closeFrcSuccessful: (state) => {
      return { ...state, loading: false };
    },

    // RTA Employees (staff for ownership transfer)
    getRtaEmployees: (state, action) => {
      return { ...state, rtaEmployeesLoading: true };
    },
    rtaEmployeesSuccessful: (state, action) => {
      return {
        ...state,
        rtaEmployeesLoading: false,
        rtaEmployees: Array.isArray(action.payload?.results) ? action.payload.results :
                     Array.isArray(action.payload) ? action.payload : [],
      };
    },
    
    // Token History
    getTokenHistory: (state, action) => {
      return { ...state, tokenHistoryLoading: true };
    },
    tokenHistorySuccessful: (state, action) => {
      return {
        ...state,
        tokenHistoryLoading: false,
        tokenHistoryList: action.payload || [],
      };
    },
    
    rtoListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.rtoparams?.page_size
      );
      console.log(action.payload);
      return {
        ...state,
        listCount: action.payload.response.count,
        newRtoList: action.payload.response.results,
        loading: false,
        rtoparams: {
          ...state.rtoparams,
          no_of_pages: noofpages,
        },
      };
    },
    setRtoParams: (state, action) => {
      return {
        ...state,
        rtoparams: action.payload,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rtoUpdateData: {
          ...state.rtoUpdateData,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rtoUpdateData: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    isDrawerVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          drawer: action.payload,
        };
      } else {
        return {
          ...state,
          drawer: action.payload,
        };
      }
    },

    isViewModalVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          viewModal: action.payload,
        };
      } else {
        return {
          ...state,
          viewModal: action.payload,
        };
      }
    },

    rtoAdd: (state, action) => {
      return {
        ...state,
        loading: true,
        rtoUpdateData: {
          id: action.payload.id,
          amount: action.payload.amount,
        },
      };
    },

    rtoAddSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        rtoUpdateData: {},
      };
    },

    getRtoById: (state) => {
      return {
        ...state,
        loading: true,
        // rtoData: action.payload,
      };
    },
    rtoByIdSuccessful: (state, action) => {
      console.log("rtoData", action.payload);
      return {
        ...state,
        loading: false,
        rtoData: action.payload,
      };
    },
    FilterInputChangeValue: (state, action) => {
      return {
        ...state,
        rtoparams: {
          ...state.rtoparams,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getRtoList,
  rtoListSuccessful,
  setRtoParams,
  InputChangeValue,
  isModelVisible,
  isDrawerVisible,
  isViewModalVisible,
  rtoAdd,
  rtoAddSuccessful,
  getRtoById,
  rtoByIdSuccessful,
  FilterInputChangeValue,
  getDocumentChecklist,
  documentChecklistSuccessful,
  uploadDocument,
  uploadDocumentSuccessful,
  verifyDocuments,
  verifyDocumentsSuccessful,
  getTokenDetails,
  tokenDetailsSuccessful,
  updateTokenDetails,
  approveToken,
  approveTokenSuccessful,
  rejectToken,
  rejectTokenSuccessful,
  setPendingReason,
  clearPendingReason,
  pendingReasonSuccessful,
  getHoldAmount,
  holdAmountSuccessful,
  getHoldHistory,
  holdHistorySuccessful,
  setHoldAmount,
  releaseHoldAmount,
  markHoldAsTransferred,
  updateRtaStatus,
  updateRtaOffice,
  updateRtaOfficeSuccessful,
  updateOwnershipStatus,
  forfeitHoldAmount,
  validateEChallan,
  validateEChallanSuccessful,
  getEchallanTransactions,
  echallanTransactionsSuccessful,
  createEchallanTransaction,
  createEchallanTransactionSuccessful,
  updateEchallanTransaction,
  updateEchallanTransactionSuccessful,
  markOwnershipTransferred,
  ownershipTransferSuccessful,
  closeRta,
  closeRtaSuccessful,
  getPurchaseHistory,
  purchaseHistorySuccessful,
  getSaleHistory,
  saleHistorySuccessful,
  getRtaHistory,
  rtaHistorySuccessful,
  getRtaEmployees,
  rtaEmployeesSuccessful,
  getTokenHistory,
  tokenHistorySuccessful,
  createFrcRta,
  createFrcRtaSuccessful,
  isFrcModalVisible,
  // ── FRC-specific actions ──────────────────────────────────
  getFrcList,
  frcListSuccessful,
  setFrcParams,
  getFrcById,
  frcByIdSuccessful,
  updateFrcStatus,
  uploadFrcDocument,
  uploadFrcDocumentSuccessful,
  verifyFrcDocuments,
  verifyFrcDocumentsSuccessful,
  getFrcDocumentChecklist,
  frcDocumentChecklistSuccessful,
  getFrcTokenDetails,
  frcTokenDetailsSuccessful,
  updateFrcTokenDetails,
  getFrcTokenHistory,
  frcTokenHistorySuccessful,
  getFrcEchallanTransactions,
  frcEchallanTransactionsSuccessful,
  createFrcEchallanTransaction,
  createFrcEchallanTransactionSuccessful,
  updateFrcEchallanTransaction,
  updateFrcEchallanTransactionSuccessful,
  markFrcOwnershipTransferred,
  frcOwnershipTransferSuccessful,
  closeFrc,
  closeFrcSuccessful,
  apiError,
} = rtoSlice.actions;

export default rtoSlice.reducer;
